import { useQuery, queryOptions } from '@tanstack/react-query';

import { QueryConfig } from '@/lib/react-query';

import httpService from '../../../lib/http.service';

interface GetDischargesPdfParams {
  contractIds?: number[];
  objectIds?: number[];
  objectItemIds?: number[];
}

export const getDischargesPdf = (params: GetDischargesPdfParams): Promise<{ data: Blob }> => {
  return httpService.get(`/objects/items/discharges/pdf`, {
    params,
    responseType: 'blob',
  });
};

export const getDischargesPdfQueryOptions = (params: GetDischargesPdfParams) => {
  return queryOptions({
    queryKey: ['discharges-pdf', params],
    queryFn: () => getDischargesPdf(params),
  });
};

type UseDischargesPdfOptions = {
  params: GetDischargesPdfParams;
  queryConfig?: QueryConfig<typeof getDischargesPdfQueryOptions>;
};

export const useDischargesPdf = ({ params, queryConfig }: UseDischargesPdfOptions) => {
  return useQuery({
    ...getDischargesPdfQueryOptions(params),
    ...queryConfig,
  });
};
